import { useEffect } from 'react';
import { useAuthContext } from '@/providers';
import { IAuthRole } from '@/providers/auth/types';
// Import DIRECT (fișierul-leaf de chei), nu prin barrel-ul '@/components' — evită ciclul hooks ↔ components.
import { P } from '@/components/permission-gate/permissions';

// ==============================|| ROLURI DISPONIBILE (lazy, gated pe roles:read) ||============================== //
// Lista de roluri (GET api/roles) NU se mai cere la bootstrap. Componentele care au nevoie de ea
// (dropdown-uri de rol, tab-uri de utilizatori, RBAC) folosesc acest hook: declanșează încărcarea
// o singură dată, DOAR dacă userul are `roles:read`. Userii fără permisiune nu mai apelează endpointul.
export const useAvailableRoles = (): IAuthRole[] => {
	const { availableRoles, loadAvailableRoles, user } = useAuthContext();
	const canReadRoles = !!user?.permissions?.includes(P.rolesRead);

	useEffect(() => {
		if (canReadRoles) loadAvailableRoles();
	}, [canReadRoles, loadAvailableRoles]);

	return availableRoles;
};
